import React, { FC } from 'react'
import { HumanName as FHIRName } from '../../../../types/FHIRTypes/HumanName'
import { getHumanName } from '../../../../utils/fhirUtils/getHumanName'
import { CodeableConcept } from '../../../../types/FHIRTypes/CodeableConcept'
import DataAbsentReason from '../../DisplayComponents/DataAbsentReason'
import Extension from '../../DataTypes/Extension'

type HumanNameProps = {
  data?: FHIRName | FHIRName[]
  dataExtension?: CodeableConcept | CodeableConcept[] | null
  showUse?: boolean
}

const HumanName: FC<HumanNameProps> = ({ data, dataExtension, showUse }) => {
  if (!data && !dataExtension) {
    return null
  }

  if (!data && dataExtension) {
    return <DataAbsentReason dataExtension={dataExtension} />
  }

  const names = Array.isArray(data) ? data : [data]
  const name = names[0]
  const humanName = getHumanName(name as FHIRName)

  return (
    <div>
      {
        humanName !== '' ? (
          <>
            {showUse && names.length > 1 && name?.use && (
              <div className="text-muted mb-1">{name.use}</div>
            )}
            <div>{humanName}</div>
          </>
        ) : (
          <Extension nestedExtension={name as FHIRName} />
        )}
    </div>
  )
}

export default HumanName